module.exports = __webpack_public_path__ + "img/sismica_2d_bacias.4e65930f.png";